<template>
    <client-page>
        <sub-visual sh="시설 및 참여" tabActive="코칭스탭" bg="/images/sub/visual/sv2.jpg"> </sub-visual>

        <section class="section">
            <v-container>
                <dept3-tab page="코칭스탭" tabActive="1" />
                <sub-staff-tab baseball />

                <staff-profile-layout v-bind="profile" />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import Dept3Tab from "@/components/client/ko/sub/dept3-tab.vue";
import SlidePrimary from "@/components/client/ko/sub/sub-slide-primary.vue";
import StaffTop from "@/components/client/ko/sub/sub-staff-top.vue";

import SubStaffTab from "@/components/client/ko/sub/sub-staff-tab.vue";
import StaffProfileLayout from "@/components/client/ko/center/staff-profile-layout.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        Dept3Tab,
        SlidePrimary,
        StaffTop,

        SubStaffTab,
        StaffProfileLayout,
    },
    data() {
        return {
            profile: [
                {
                    position: "총감독",
                    name: "현남수",
                    items: [
                        {
                            subject: "학력 / 경력",
                            content: [
                                "부산고등학교",
                                "중앙대학교",
                                "롯데자이언츠",
                                "청소년 ~ 성인 국가대표 선수",
                                //
                            ],
                        },
                        {
                            subject: "상훈 / 자격증",
                            content: [
                                "1982 봉황대기 타격,타점왕",
                                "1983 세계청소년야구대회 도루상",
                                "1983,4 화랑대기 타격, 최다안타, 도루상",
                                //
                            ],
                        },
                        {
                            subject: "지도",
                            content: [
                                "(전)감독자 협의회 회장",
                                "(전)리틀야구 연맹이사",
                                "(전)리틀야구 대표 선발위원장",
                                "(현)하남리틀감독",
                                //
                            ],
                        },
                        {
                            subject: "이메일",
                            content: [
                                "hanam@uthestar.org",
                                //
                            ],
                        },
                    ],
                    image: "/images/sub/center/staff/staff-01.jpg",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped></style>
